<template>
  <div>
    <UserActionsWrap form-title="Create<br> your account">
      <RegistrationForm />
    </UserActionsWrap>
    <UserActionsNavigation />
  </div>
</template>

<script>
  import UserActionsWrap from "../components/UserActionsWrap";
  import RegistrationForm from "../components/RegistrationForm";
  import UserActionsNavigation from "../components/UserActionsNavigation";

  export default {
    name: "Registration",
    components: {
      UserActionsWrap,
      RegistrationForm,
      UserActionsNavigation
    }
  }
</script>

